import axios from '../api/axiosSetup3';
import { EventRecord, EventImage } from '../types/event';

/*
const _get = async ({ from, to }: { from: Date; to: Date } ): Promise<EventRecord[]> => {
    const customer_id = import.meta.env.VITE_CUSTOMER_ID;
    const res = await axios.get<EventRecord[]>(`/v_event`);

    return res.data;

    return res.data.map(val => ({
        ...val, 
        dt_start: val.ts_start ? new Date(val.ts_start) : undefined, 
        dt_stop: val.ts_end ? new Date(val.ts_end): undefined,
    }));
};
*/

const get = async ({ from, to }: { from: string; to: string }): Promise<EventRecord[]> => {

    // Преобразуем Date в ISO строку
    // const fromISO = from.toISOString();
    // const toISO = to.toISOString();

    const res = await axios.get<EventRecord[]>(`/v_event_ext?ts_start=gte.${from}&ts_start=lte.${to}`);
    return res.data;
};

const get_BAD = async ({ from, to }: { from: string; to: string }): Promise<EventRecord[]> => {

    // Преобразуем Date в ISO строку
    // const fromISO = from.toISOString();
    // const toISO = to.toISOString();

    const res = await axios.get<EventRecord[]>(`/v_event_ext?ts_start=gte.${from}&ts_start=lte.${to}`,  {
        params: {
            order: 'id.desc',
            // select: '*,ext:lpr_subtenant_to_group(customer_id, group_id)',
            select: '*,lpr_subtenant_to_group!inner(*)',
            limit: 1
        }
    });
    return res.data;
};

const getFiltered = async ({ registration_number, from, to }: { registration_number: string; from: string; to: string }): Promise<EventRecord[]> => {
    // const res = await axios.get<EventRecord[]>(`/v_event_ext?ts_start=gte.${from}&ts_start=lte.${to}&registration_number=eq.${registration_number}`);
    if (registration_number) {
        const res = await axios.get<EventRecord[]>(`/v_event_ext?registration_number=eq.${registration_number}&limit=10`);
        return res.data;
    } else {
        const res = await axios.get<EventRecord[]>(`/v_event_ext?limit=10`);
        return res.data;
    }
};

const getShort = async ({ limit }: { limit: number }): Promise<EventRecord[]> => {

    const res = await axios.get<EventRecord[]>(`/v_event_ext`, {
        params: {
            order: 'id.desc',
            limit,
        }
    });
    return res.data;
};

const getImage = async ({ origin_id, uuid }: { origin_id: number; uuid: string }): Promise<EventImage> => {
    const res = await axios.post<EventImage>('/rpc/get_event_images', { origin_id, uuid, });
    // CREATE OR REPLACE FUNCTION "lpr"."get_event_images"("origin_id" int4, "uuid" text)
    return res.data;
}

// import Plates from video camera
// const importPlates = async ({ origin_id }: { origin_id: number }): Promise<string[]> => {
//     const res = await axios.post<string[]>('/rpc/plates_action', { 
//         entity_id_inp: origin_id, 
//         action: 'get',
//     });
//     return res.data;
// }

const delete_ = async (event_id: number): Promise<void> => {
    await axios.delete<EventRecord>(`/lpr_event?event_id=eq.${event_id}`);
}


const getLastEvent = async (): Promise<EventRecord[]> => {
    const res = await axios.get<EventRecord[]>(`/v_event_ext`, {
        params: {
            order: 'id.desc',
            limit: 1
        }
    });
    return res.data;
};

// для subtenant-ов
const getLastEventSubtenant = async (): Promise<EventRecord[]> => {
    const res = await axios.get<EventRecord[]>(`/v_event_ext`, {
        params: {
            order: 'id.desc',
            select: '*,ext:lpr_subtenant_to_group(customer_id, group_id)',
            limit: 1
        }
    });
    return res.data;
};

const getLastImage = async (): Promise<EventImage> => {
    const res1 = await axios.get<EventRecord[]>(`/v_event_ext`, {
        params: {
            order: 'id.desc',
            limit: 1,
        }
    });
    if (res1.data.length === 0) {
        return {
            background: '',
            object: '',
            origin_name: '',
            result: false,
            ts_start: '',
        };
    }
    const origin_id = res1.data[0].entity_id;
    const uuid = res1.data[0].uuid;
    const res2 = await axios.post<EventImage>('/rpc/get_event_images', { origin_id, uuid, } );
    return {...res2.data, origin_name: res1.data[0].origin_name, ts_start: res1.data[0].ts_start};
}


export const api = {
    get,
    getFiltered,
    // getShort,
    getImage,
    // importPlates,
    delete: delete_,
    getLastEvent,
    // getLastEventSubtenant,
    getLastImage,
};